"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _main = _interopRequireDefault(require("./main.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = {
  axiosWarpper: function axiosWarpper(item, dataList, methodList, mounted) {
    var api = "";
    if (item.body) {
      //解析地址栏取值？？？
      item.body = _main["default"].execute(item.body);
    }
    var proxy = JSON.parse(sessionStorage.getItem("proxy")) || {};
    //测试环境接口请求方式
    if (window.LOWCODE['power'].includes(window.location.hostname) && proxy['isProxy']) {
      var branchId = window.location.pathname.split('/').slice(-1).join();
      var repositoryId = _main["default"].getRepId(item.proxy, item.body);
      api = function api() {
        for (var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++) {
          arg[_key] = arguments[_key];
        }
        var request = window.LOWCODE['axios'].POST({
          method: 'POST',
          url: "/zqyl-lowcode-api/rap/mock",
          data: {
            targetType: _main["default"].getAxiosBase(item).indexOf('rap.corp.yljr.com') != -1 ? 1 : 2,
            method: item.method,
            url: _main["default"].getAxiosBase(item) + item.body,
            headerMap: {
              'Content-Type': item.contentType || _main["default"].contentType.get
            },
            paramMap: _main["default"].getParams(item, arg),
            token: proxy[branchId] ? proxy[branchId] : '',
            repositoryId: repositoryId
          }
        });
        request.then(function (res) {
          if (res.data.status == "M0200") {
            window.LOWCODE.source[item.target].data = res.data.data;
            _main["default"].executeEvent(item.success, res)();
          }
        })["catch"](function (err) {
          _main["default"].executeEvent(item.error, err)();
        });
        return request;
      };
    } else {
      var requestThen = function requestThen(request, item) {
        request.then(function (res) {
          if (res.data.status == "M0200") {
            window.LOWCODE.source[item.target].data = res.data.data;
            _main["default"].executeEvent(item.success, res)();
          }
        })["catch"](function (err) {
          _main["default"].executeEvent(item.error, err)();
        });
      };
      //生成环境请求方式
      if (item.method == "GET") {
        api = function api() {
          for (var _len2 = arguments.length, arg = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            arg[_key2] = arguments[_key2];
          }
          var request = window.LOWCODE['axios'].GET({
            headers: {
              'Content-Type': item.contentType || _main["default"].contentType.get
            },
            method: item.method,
            url: item.body,
            params: _main["default"].getParams(item, arg)
          });
          if (!item.isload) {
            requestThen(request, item);
          }
          return request;
        };
      }
      if (item.method == "POST") {
        api = function api() {
          for (var _len3 = arguments.length, arg = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            arg[_key3] = arguments[_key3];
          }
          var request = window.LOWCODE['axios'].POST({
            headers: {
              'Content-Type': item.contentType || _main["default"].contentType.post
            },
            method: item.method,
            url: item.body,
            data: _main["default"].getParams(item, arg)
          });
          if (!item.isload) {
            requestThen(request, item);
          }
          return request;
        };
      }
    }
    dataList.push("\n            ".concat(item.target, ":null,\n        "));
    if (item.isload) {
      methodList.push("\n                ".concat(item.target, "Method(){\n                    window.LOWCODE.source.").concat(item.target, ".run().then(res=>{\n                        this.").concat(item.target, " = res.data;\n                        ").concat(this.createFunctionBody(window.LOWCODE.source[item.target].success, '', 'res'), "\n                    }).catch(err =>{\n                        ").concat(this.createFunctionBody(window.LOWCODE.source[item.target].error, '', 'res'), "\n                    })\n                },\n            "));
      mounted.push("\n                this.".concat(item.target, "Method();\n            "));
    }
    window.LOWCODE.source[item.target].run = api;
  },
  mixinInitMethod: function mixinInitMethod(dataSource, dataList, methodList, mounted) {
    var _this2 = this;
    var apis = dataSource.find(function (item) {
      return item.type == 'api';
    });
    if (apis) {
      apis.children.forEach(function (item) {
        //加载页面所有API方法
        _this2.axiosWarpper(item, dataList, methodList, mounted);
      });
    }
  },
  mixinInitMounted: function mixinInitMounted(dataSource, dataList, methodList, mounted) {
    var js = dataSource.find(function (item) {
      return item.type == 'js';
    });
    if (js) {
      js.children.forEach(function (item) {
        //初始化加载页面所有js方法
        mounted.push("\n                    window.LOWCODE.source.".concat(item.target, ".init && window.LOWCODE.source.").concat(item.target, ".init();\n                "));
      });
    }
  },
  createFunctionBody: function createFunctionBody(bindEvent, scheme, params) {
    if (!bindEvent) {
      return false;
    }
    if (bindEvent.isAction && bindEvent.method[0] == "js") {
      params = params ? params : "data";
      return "window.LOWCODE.source.".concat(bindEvent.method[1], ".").concat(bindEvent.method[2], "(").concat(params, ");");
    }
    if (bindEvent.isAction && bindEvent.method[0] == "api") {
      if ("this.".concat(bindEvent.method[1])) {
        return "window.LOWCODE.source.".concat(bindEvent.method[1], ".run().then(res => {\n                    this.").concat(bindEvent.method[1], " = res.data;\n                    ").concat(this.createFunctionBody(window.LOWCODE.source[bindEvent.method[1]].success, '', 'res'), "\n                }).catch(err => {\n                    ").concat(this.createFunctionBody(window.LOWCODE.source[bindEvent.method[1]].error, '', 'res'), "\n                })");
      } else {
        return "window.LOWCODE.source.".concat(bindEvent.method[1], ".run()");
      }
    }
    if (!bindEvent.isAction && bindEvent.body) {
      return "".concat(_main["default"].replaceRefs(bindEvent.body), ";");
    }
    //跳转
    if (bindEvent.method[0] == "3") {
      return this.createRouter(bindEvent);
    }
    //消息提示
    if (bindEvent.method[0] == "4") {
      return this.createMessage(bindEvent);
    }
    //打开弹窗
    if (bindEvent.method[0] == "5") {
      return this.createOpenDialog(bindEvent);
    }
    //关闭弹窗
    if (bindEvent.method[0] == "6") {
      return this.createCloseDialog(bindEvent);
    }
    //图片预览
    if (bindEvent.method[0] == "7") {
      return this.createImagesPrview(bindEvent, scheme);
    }
    return "";
  },
  //跳转
  createRouter: function createRouter(bindEvent) {
    var query = {};
    var path = '';
    if (bindEvent.isInputPage) {
      path = bindEvent.page.startsWith('/') ? bindEvent.page : "/".concat(bindEvent.page);
    } else {
      path = "/lc/".concat(bindEvent.page);
    }
    if (bindEvent.router == "url") {
      path = bindEvent.url;
    }
    if (bindEvent.body) {
      query = _main["default"].execute(bindEvent.body);
    }
    query = JSON.stringify(query);
    if (bindEvent.target == "_blank") {
      return "\n                let newRouter = router.resolve({\n                    path:'".concat(path, "',\n                    query:").concat(query, "\n                });\n                window.open(newRouter.href,").concat(bindEvent.target, ");\n            ");
    }
    if (bindEvent.target == '_self' && bindEvent.router == "url") {
      return "\n                let newRouter = router.resolve({\n                    path:'".concat(path, "',\n                    query:").concat(query, "\n                });\n                location.href = newRouter.href;\n            ");
    }
    return "window.LOWCODE.app.$router.push({\n            path: '".concat(path, "',\n            query: ").concat(query, "\n        })");
  },
  //消息提示
  createMessage: function createMessage(bindEvent) {
    var msg = _main["default"].execute(bindEvent.body);
    return "this.$message({\n            message: '".concat(msg, "',\n            type: '").concat(bindEvent.messageType, "'\n        });\n        return false;");
  },
  //打开弹窗
  createOpenDialog: function createOpenDialog(bindEvent) {
    return "this.$refs.".concat(bindEvent.dialog, ".visible = true;");
  },
  //关闭弹窗
  createCloseDialog: function createCloseDialog(bindEvent) {
    return "this.$refs.".concat(bindEvent.dialog, ".visible = false;");
  },
  //图片预览
  createImagesPrview: function createImagesPrview(bindEvent) {
    return "\n            this.imageViewDataList = ".concat(_main["default"].replaceObjectChars(bindEvent.body), ";\n            this.imageViewVisible = true;\n        ");
  },
  //生成API方法
  createFunction: function createFunction(eventList, scheme, methodList) {
    var _this3 = this;
    var config = scheme.__config__;
    if (eventList instanceof Array) {
      eventList.forEach(function (item, index) {
        //过滤未设置 或 选择无动作
        if (item.isAction && item.method.length > 0 && item.method[0] != 0) {
          var functionName = "".concat(item.eventName).concat(config.target, "Method").concat(item.method[item.method.length - 1]);
          methodList.push("\n                    ".concat(functionName, "(data){\n                            ").concat(_this3.createFunctionBody(item, scheme), "\n                            ").concat(_this3.specialCase(scheme), "\n                        },"));
        }
        if (!item.isAction && item.body) {
          var _functionName = "".concat(item.eventName).concat(config.target, "Method");
          methodList.push("\n                        ".concat(_functionName, "(data){\n                            ").concat(_this3.createFunctionBody(item, scheme), "\n                            ").concat(_this3.specialCase(scheme), "\n                        },"));
        }
      });
    }
  },
  //特殊逻辑处理
  specialCase: function specialCase(scheme) {
    var config = scheme.__config__;
    //yl-search组件，将数据向外层赋值
    if (config.tagType == "search" && config.body) {
      return "this.".concat(_main["default"].replaceChars(config.body), " = data;");
    }
    return '';
  },
  createUpdateTableData: function createUpdateTableData(scheme, methodList, mounted) {
    var _this = this;
    var config = scheme.__config__;
    var functionName = "update".concat(config.target, "Data");
    var list = [];
    list.push("let _this = this;");
    scheme.data.header.map(function (item, index) {
      if (item.attr.type == 'handle' && item.attr.handle.length > 0) {
        item.attr.handle.forEach(function (child, childIndex) {
          var condition = child.isShow.isAction ? child.isShow.status : _main["default"].replaceObjectChars(child.isShow.body);
          list.push("this.".concat(config.target, "Data.header[").concat(index, "].attr.handle[").concat(childIndex, "].condition = '").concat(condition, "'"));
          if (child.__on__ && child.__on__.length > 0) {
            _this.createFunction(child.__on__, scheme, methodList);
            child.__on__.forEach(function (itemChild) {
              list.push("this.".concat(config.target, "Data.header[").concat(index, "].attr.handle[").concat(childIndex, "].callback = function(row){\n                                _this.").concat(itemChild.eventName).concat(config.target, "Method").concat(itemChild.method[itemChild.method.length - 1], "(row);\n                            }"));
            });
          }
        });
      }
      if ((item.attr.type == "enum" || item.attr.type == "inputSelect") && item.attr.body) {
        list.push("\n                    this.$watch('source.".concat(_main["default"].replaceChars(item.attr.body), "',(list)=>{\n                        if(list instanceof Array && list.length>0){\n                            _this.").concat(config.target, "Data.header[").concat(index, "].attr.data = list;\n                        }\n                    },{\n                        immediate: true,\n                    });\n                "));
      }
    });
    //加载后执行
    mounted.push("this.".concat(functionName, "();"));
    //输出更新数据方法
    methodList.push("".concat(functionName, "(){\n            ").concat(list.join('\n'), "\n        },"));
  },
  transRules: function transRules(regList) {
    var rule = [];
    if (regList && regList.length && regList.length > 0) {
      regList.map(function (item) {
        if (item.digit) {
          rule.push(window.LOWCODE.app.$function.RULES[item.name](item.message, item.digit, item.trigger));
        } else if (item.min && item.max) {
          rule.push(window.LOWCODE.app.$function.RULES[item.name](item.message, item.min, item.max, item.trigger));
        } else if (item.cnen != undefined && item.supportNum != undefined) {
          rule.push(window.LOWCODE.app.$function.RULES[item.name](item.message, item.cnen, item.supportNum, item.trigger));
        } else {
          rule.push(window.LOWCODE.app.$function.RULES[item.name](item.message));
        }
      });
    }
    return rule;
  },
  //创建yl-lc-title动态数据
  createTitle: function createTitle(el) {
    var config = el.__config__;
    var title = "'".concat(el.title, "'");
    var subTitle = "'".concat(el.subTitle, "'");
    return "{\n\t\t\tmain:".concat(config.mainTitle.isAction ? title : _main["default"].replaceObjectChars(config.mainTitle.body), ",\n\t\t\tsub:").concat(config.subTitle.isAction ? subTitle : _main["default"].replaceObjectChars(config.subTitle.body), ",\n\t\t}");
  },
  //创建el-collapse动态数据
  createCollapseStatus: function createCollapseStatus(el, data, index) {
    var config = el.__config__;
    return "\n\t\t\t".concat(config.target).concat(index, "Disabled:").concat(data.isDisabled.isAction ? data.disabled : _main["default"].replaceObjectChars(data.isDisabled.body), ",\n\t\t\t").concat(config.target).concat(index, "Display:").concat(data.isShow.isAction ? data.isShow.status : _main["default"].replaceObjectChars(data.isShow.body), ",\n\t\t");
  },
  //创建是否禁用和是否显示
  createStatus: function createStatus(el) {
    var config = el.__config__;
    return "\n\t\t\t".concat(config.target, "Disabled:").concat(config.isDisabled.isAction ? el.disabled : _main["default"].replaceObjectChars(config.isDisabled.body), ",\n\t\t\t").concat(config.target, "Display:").concat(config.tag === 'yl-lc-button' ? el.isShow.isAction ? el.isShow.status : _main["default"].replaceObjectChars(el.isShow.body) : config.isShow.isAction ? config.isShow.status : _main["default"].replaceObjectChars(config.isShow.body), ",\n        ");
  },
  //创建yl-echars-line
  createEcharsLine: function createEcharsLine(el, methodList, mounted) {
    var _this = this;
    var list = [];
    var config = el.__config__;
    var functionName = "update".concat(config.target, "Data");
    list.push("\n            this.".concat(config.target, ".seriesJson.map(item=>{\n                if(item.body!=\"\"){\n                    let char = item.body.indexOf(\"{{\");\n                    if(char==-1){\n                        item.data = item.body.split(\",\");\n                    }else{\n                        item.data = this.$lowcode.replaceObjectChars(item.body);\n                    }\n                }\n            });\n        "));
    //加载后执行
    mounted.push("this.".concat(functionName, "();"));
    //输出更新数据方法
    methodList.push("".concat(functionName, "(){\n            ").concat(list.join('\n'), "\n        },"));
  },
  //创建yl-echars-pie
  createEcharsPie: function createEcharsPie(el, methodList, mounted) {
    var _this = this;
    var list = [];
    var config = el.__config__;
    var functionName = "update".concat(config.target, "Data");
    list.push("\n            this.".concat(config.target, ".series.map(item=>{\n                if(item.data!=\"\"){\n                    let char = item.data.indexOf(\"{{\");\n                    if(char!=-1){\n                        item.data = this.$lowcode.replaceObjectChars(item.data);\n                    }\n                }\n            });\n        "));
    //加载后执行
    mounted.push("this.".concat(functionName, "();"));
    //输出更新数据方法
    methodList.push("".concat(functionName, "(){\n            ").concat(list.join('\n'), "\n        },"));
  }
};
exports["default"] = _default;